<template>
  <van-popup :value="value" @input="input" position="bottom" round>
    <div class="popup-nfc flex flex-col items-center">
      <span class="text-18px">{{ msg.title }}</span>
      <div class="mt-20  relative"
          style="border-radius: 50%;width:150px;height:150px;overflow: hidden">
        <van-image class="absolute top-0 bottom-0 left-0 right-0 mt-15 nfc-anim "
            :src="require('@/assets/icons/v2/icon_nfc_read_write.svg')" width="150"
            height="150"/>
        <div style="background: rgba(103,154,255,0.1);border-radius: 50%;" class="absolute top-0 bottom-0 left-0 right-0"></div>
      </div>
      <span class="text-17px mt-3">{{ msg.message }}</span>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: "NFCPopup",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    msg: {
      type: Object,
      default: () => {
        return {
          title: "Read to Read",
          message: "Place your product in the NFC area"
        };
      }
    }
  },
  methods: {
    input() {
      this.$emit("input");
    }
  }
};
</script>


<style scoped lang="less">
.popup-nfc {
  border-radius: 16px;
  background: white;
  height: 352px;
  text-align: center;
  padding: 16px;
}

@keyframes rotateX {
  0% {
    transform: rotateX(0deg);
    margin-top:60px;
  }
  50% {
    transform: rotateX(40deg);
    margin-top:30px;
  }
  100% {
    transform: rotateX(0deg);
    margin-top:60px;
  }
}

.rotate-x {
  animation: rotateX 2s ease-in-out infinite;
}

.nfc-anim {
  animation: rotateX 2.5s ease-in-out infinite;
}
</style>